import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../../components/CustomLoader";
import { apiCms } from "../../../services/AllServices";
import errorHandler from "../../../utils/errorHandler";
import { capitalize } from "../../../utils/helpers";

const ViewFaqDetail = ({ id, show, onHide }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFullAnswer, setShowFullAnswer] = useState(false);

  const fetchFaqDetails = async () => {
    try {
      setLoading(true);
      const response = await apiCms.getByIdFaq({ id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFaqDetails();
    }
  }, [id]);

  const toggleAnswerView = () => {
    setShowFullAnswer((prev) => !prev);
  };

  return (
    <Dialog maxWidth="md" fullWidth open={show} onClose={onHide}>
      <DialogTitle>FAQ Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Question</Typography>
              <DialogContentText sx={{ mt: 1 }}>
                {capitalize(data?.question) || "N/A"}
              </DialogContentText>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Answer</Typography>
              <DialogContentText>
                <Typography
                  className="list-data"
                  dangerouslySetInnerHTML={{
                    __html: showFullAnswer
                      ? data?.answer || "N/A"
                      : (data?.answer?.slice(0, 150) || "N/A") + (data?.answer?.length > 150 ? "..." : ""),
                  }}
                />
                {data?.answer?.length > 150 && (
                  <Button onClick={toggleAnswerView} sx={{ mt: 1 }}>
                    {showFullAnswer ? "View Less" : "View More"}
                  </Button>
                )}
              </DialogContentText>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">
                Status: {capitalize(data?.status) || "N/A"}
              </Typography>
            </Grid>
          </Grid>
          <DialogActions>
            <Button variant="outlined" onClick={onHide}>
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewFaqDetail;
